import { Mode } from 'mk2/containers/PhoneVerification/PhoneVerification.constants';
import { Action } from 'redux';

export const PHONE_VERIFICATION_MODAL_SHOW = 'PHONE_VERIFICATION_MODAL_SHOW';

export interface PhoneVerificationModalShowAction extends Action {
    readonly type: typeof PHONE_VERIFICATION_MODAL_SHOW;
    readonly mode: Mode;
}

export const phoneVerificationModalShow = (mode: Mode): PhoneVerificationModalShowAction => ({
    type: PHONE_VERIFICATION_MODAL_SHOW,
    mode,
});

export const PHONE_VERIFICATION_MODAL_CLOSE = 'PHONE_VERIFICATION_MODAL_CLOSE';

export interface PhoneVerificationModalCloseAction extends Action {
    readonly type: typeof PHONE_VERIFICATION_MODAL_CLOSE;
}

export const phoneVerificationModalClose = (): PhoneVerificationModalCloseAction => ({
    type: PHONE_VERIFICATION_MODAL_CLOSE,
});
